<template>
  <a-modal
    ref="authRole"
    :title="'分配角色'"
    :width="900"
    :open="visible"
    :confirm-loading="submitLoading"
    @cancel="close"
    @ok="confirm"
  >
    <div class="page-header-content">
      <a-card :bordered="false" class="content">
        <a-table
          :loading="loading"
          :size="tableSize"
          rowKey="id"
          :columns="columns"
          :data-source="list"
          :row-selection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange,
          }"
          :scroll="{ y: tableHeight }"
          :pagination="false"
          :bordered="tableBordered"
        >
          <template #createTime="{ text, record }">
            <span>
              {{ parseTime(record.createTime) }}
            </span>
          </template>
        </a-table>
      </a-card>
    </div>
  </a-modal>
</template>

<script setup>
import { ref, reactive, computed, nextTick, onMounted } from 'vue'
import { useStore } from 'vuex'
import { message } from 'ant-design-vue'
import { $emit } from '../../../../utils/gogocodeTransfer'
import { getAuthRole, updateAuthRole } from '@/api/system/user'
import { parseTime } from '@/utils/ruoyi'

defineOptions({
  name: 'AuthRole',
})

const emit = defineEmits(['ok'])
const store = useStore()

// tableMixin 的功能
const tableBordered = computed(() => store.state.app.tableBordered)
const tableSize1 = ref('')
const tableSize = computed({
  get() {
    return tableSize1.value || store.state.app.tableSize
  },
  set(value) {
    tableSize1.value = value
  }
})

// 响应式数据
const list = ref([])
const user = ref({})
const selectedRowKeys = ref([])
const selectedRows = ref([])
const tableHeight = ref(document.documentElement.scrollHeight - 500 + 'px')
const roleIds = ref([])
const loading = ref(false)
const submitLoading = ref(false)
const visible = ref(false)
const single = ref(true)
const multiple = ref(true)

const columns = ref([
  {
    title: '角色编号',
    dataIndex: 'id',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '角色名称',
    dataIndex: 'roleName',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '权限字符',
    dataIndex: 'roleKey',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    slots: { customRender: 'createTime' },
    align: 'center',
  },
])

// 方法
// 查询表数据
const getList = (userId) => {
  loading.value = true
  getAuthRole(userId).then((res) => {
    if (res.code == 20001) {
      list.value = res.data.roles
      user.value = res.data.user
      nextTick(() => {
        const roleIdsArray = res.data.user.roles.map((item) => item.id)
        roleIds.value = roleIdsArray
        selectedRowKeys.value = roleIdsArray
      })
      loading.value = false
    }
  })
}

// 关闭模态框
const close = () => {
  visible.value = false
  selectedRowKeys.value = []
  selectedRows.value = []
}

// 打开(由外面的组件调用)
const handleAuthRole = (row) => {
  visible.value = true
  getList(row.id)
}

// 确认
const confirm = () => {
  submitLoading.value = true
  updateAuthRole({ userId: user.value.id, roleIds: roleIds.value })
    .then((res) => {
      message.success(res.message)
      visible.value = false
      emit('ok')
    })
    .finally(() => {
      submitLoading.value = false
    })
}

const onSelectChange = (keys, rows) => {
  selectedRowKeys.value = keys
  selectedRows.value = rows
  roleIds.value = rows.map((item) => item.id)
  single.value = keys.length !== 1
  multiple.value = !keys.length
}

// 暴露方法给父组件
defineExpose({
  handleAuthRole,
})
</script>
